import { getArchivalAidQuote } from 'modules/archival-aid/utils/get-archival-aid-quote';
import { ArchivalAidMetadata, ArchivalUnitReference } from 'types';
import { separatorJoin, SeparatorJoinItem } from 'utils/separatorJoin';

export const getArchivalUnitQuote = (
  archivalUnitReference?: ArchivalUnitReference,
  archivalAid?: ArchivalAidMetadata,
  summary?: string,
  label?: string
) => {
  const archivalAidQuote = archivalAid
    ? getArchivalAidQuote(archivalAid)
    : undefined;

  const { structuredLink, nonStructuredLink } = archivalUnitReference ?? {};
  const includeStructureLink =
    archivalAid && (structuredLink || nonStructuredLink);

  const structureLinkParts = [
    'r.ozn./inv.č./sign.: ',
    structuredLink ? `${structuredLink}${nonStructuredLink ? '/' : ''}` : '',
    nonStructuredLink ?? '',
  ];

  const structureLink = includeStructureLink
    ? structureLinkParts.join('')
    : undefined;

  const timeRange = archivalUnitReference?.timeRange;
  const collectionName = archivalUnitReference?.archivalCollection?.name ?? '-';

  const quoteParts: SeparatorJoinItem[] = [
    ['Archiv Univerzity Karlovy', '; '],
    [`fond ${collectionName}`, '; '],
    archivalAidQuote ? [`pomůcka: ${archivalAidQuote}`, '; '] : 'nezpracováno',
    structureLink,
    archivalAid
      ? undefined
      : `číslo archiválie: ${archivalUnitReference?.numericId}`,
    summary ? summary : 'blíže neurčeno',
    timeRange ?? '',
  ];

  return `${separatorJoin(quoteParts, ', ')}${label ? `; ${label}` : ''}.`;
};
